<template>
    <kgr-club-fee-data-provider
        :club-id="clubId"
        :callback="onClubFeesLoaded"
    >
        <div>
            <kgr-club-fee-category-data-provider
                :club-id="clubId"
                :callback="onClubFeeCategoriesLoaded"
            >
                <div>
                    <kgr-club-dunning-settings-data-provider
                        v-slot="clubDunningSettingsScope"
                        :club-id="clubId"
                        :callback="onClubDunningSettingsLoaded"
                    >
                        <div class="animated fadeIn">
                            <kgr-form-scaffold
                                :pending="pending"
                                :with-back-button="false"
                                :save-button-disabled="saveButtonDisabled"
                                :with-primary-buttons="isEditable"
                                @primaryBtnClicked="precheckUpdate(clubDunningSettingsScope.reload)"
                            >
                                <div class="kgr-row">
                                    <kgr-club-dunning-settings-form
                                        :error="error"
                                        :club-fees="clubFees"
                                        :club-fee-categories="clubFeeCategories"
                                        :club-dunning-settings.sync="clubDunningSettings"
                                        class="animated fadeIn"
                                        @enter="precheckUpdate(clubDunningSettingsScope.reload)"
                                    />
                                </div>
                            </kgr-form-scaffold>
                        </div>
                    </kgr-club-dunning-settings-data-provider>
                </div>
            </kgr-club-fee-category-data-provider>
        </div>
    </kgr-club-fee-data-provider>
</template>

<script>
import ClubDunningSettingsDataProvider from '../../../components/data-provider/ClubDunningSettingsDataProvider';
import ClubDunningSettingsForm from '../../../components/club/dunning-settings/ClubDunningSettingsForm';
import ClubDunningSettingsRepository from '../../../js/repository/ClubDunningSettingsRepository';
import ClubFeeCategoryDataProvider from '../../../components/data-provider/ClubFeeCategoryDataProvider';
import ClubFeeDataProvider from '../../../components/data-provider/ClubFeeDataProvider';
import ClubInvoiceRepository from '../../../js/repository/ClubInvoiceRepository';
import Error from '../../../js/model/Error';
import FormScaffold from '../../../components/common/form/FormScaffold';

export default {
    components: {
        'kgr-club-dunning-settings-data-provider': ClubDunningSettingsDataProvider,
        'kgr-club-dunning-settings-form': ClubDunningSettingsForm,
        'kgr-club-fee-category-data-provider': ClubFeeCategoryDataProvider,
        'kgr-club-fee-data-provider': ClubFeeDataProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            clubDunningSettings: null,
            clubFees: null,
            clubFeeCategories: null,
            pending: false,
            dunningLevel1Enabled: null,
        };
    },
    computed: {
        saveButtonDisabled() {
            return this.clubDunningSettings === null;
        },
    },
    methods: {
        onClubDunningSettingsLoaded(loadedClubDunningSettings) {
            this.clubDunningSettings = loadedClubDunningSettings;
            this.dunningLevel1Enabled = this.clubDunningSettings.clubDunningLevel1.enabled;
        },
        onClubFeesLoaded(loadedClubFees) {
            this.clubFees = loadedClubFees;
        },
        onClubFeeCategoriesLoaded(loadedClubFeeCategories) {
            this.clubFeeCategories = loadedClubFeeCategories;
        },
        precheckUpdate(reload) {
            if (!this.clubDunningSettings.clubDunningLevel1.enabled && this.dunningLevel1Enabled === true) {
                this.pending = true;
                ClubInvoiceRepository.getCountByClubIdForDunningLevel1(this.clubId)
                    .then((response) => {
                        showConfirm(this.$t('confirmInformal'), this.$t('club.dunningSettings.dunningLevel1.deactivate.confirm', { count: response }), () => {
                            this.update(reload);
                        }, 'Ok');
                    })
                    .finally(() => this.pending = false);
            } else {
                this.update(reload);
            }
        },
        update(reload) {
            this.pending = true;
            ClubDunningSettingsRepository.update(this.clubId, this.clubDunningSettings)
                .then(() => {
                    this.error = new Error();
                    reload();
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
